// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"889":"9a8b014b","938":"dcb0d0d8"}[chunkId] + ".chunk.js";
};